import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { FailedSolutions } from './components/FailedSolutions';
import { MicroReleaseMethod } from './components/MicroReleaseMethod';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsThisFor } from './components/WhoIsThisFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FaqSection } from './components/FaqSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-dark text-white font-sans selection:bg-cyan-accent selection:text-dark" data-id="element-0">
      <HeroSection data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <FailedSolutions data-id="element-4" />
      <MicroReleaseMethod data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoIsThisFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <ProofSection data-id="element-9" />
      <FaqSection data-id="element-10" />
      <PricingSection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}